import React from 'react'
import Logo from "/assets/images/swayamRiskLogoBlue.png";
import style from "./wayforward.module.css";
import Bg from "/assets/PdfNew/pgbg14.png";


const WayForward = () => {
    return (
        <div className={style.wayforwardBg}>
            {/* Background */}
            <img src={Bg} alt="background" className={style.wayforwardBg} />

            {/* Logo */}
            <img src={Logo} alt="logo" className={style.logo} />


            {/* Content */}
            <div className={style.content}>
                <p className={style.title}>
                    <strong>Way Forward</strong>
                </p>
                <br></br>


                <p   >
                   Your report is just the beginning—the real journey starts now.
<br></br>
Everything you've discovered about yourself today can be transformed into meaningful action through the SwayamRise portal. Set your goals, track your progress, connect with expert counsellors, explore leading colleges, and receive personalized guidance from your AI Buddy—all tailored to your unique aspirations.
<br></br>

The students who turn insights into action are the ones who move ahead with confidence. Log in, explore the opportunities available to you, and take the next step toward your future.
<br></br>

We're with you every step of the way.

                </p>

            </div>

        </div>
    )
}

export default WayForward